import ApplicationAdapter from './application';

export default class ComponentReviewThreadAdapter extends ApplicationAdapter {
  namespace = 'api/v2';
}
